import { useRef, useEffect } from 'react'

/**
 * This hook is used in conjunction with a useEffect where we need to check
 * the current value in the effect against a previous value, set by this.
 *
 * @param {any} value The value we want to store for next time
 * @returns {any} The value from the previous render
 */
export const usePrevious = value => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
